export default __webpack_public_path__ + "static/media/SB2.dac0c9b2.jpg";